(() => {
  function init(root) {
    if (root.dataset.bbcaInit) return;
    root.dataset.bbcaInit = '1';
    const form = root.querySelector('#BBCAProductEnquiryForm');
    const details = root.querySelector('.bbca-enquiry-details');
    // Set the initial state only: desktop open, mobile closed.
    // Native submission results remain visible at every viewport size.
    // Subsequent user toggles and viewport changes are not overridden.
    const hasSubmissionResult = Boolean(root.querySelector('[data-bbca-success], .bbca-form-error'));
    details.open = hasSubmissionResult || window.matchMedia('(min-width: 750px)').matches;
    const type = root.querySelector('[data-bbca-type]');
    const wa = root.querySelector('[data-bbca-wa]');
    const email = root.querySelector('[data-bbca-email]');
    const read = selector => root.querySelector(selector);
    let variants = [];
    try { variants = JSON.parse(read('[data-bbca-variants]').textContent); } catch (_) {}
    let active = null;
    function selectedVariant() {
      const id = new URLSearchParams(location.search).get('variant');
      const picker = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const pickerId = picker && picker.value;
      return variants.find(v => String(v.id) === id) ||
        variants.find(v => String(v.id) === pickerId) ||
        variants.find(v => v.available) || variants[0] || null;
    }
    function context() {
      const variant = selectedVariant();
      const variantTitle = variant && variant.title !== 'Default Title' ? variant.title : 'Standard configuration';
      const sku = variant && variant.sku ? variant.sku : 'Not specified';
      const productUrl = new URL(root.dataset.url, location.origin);
      if (variant) productUrl.searchParams.set('variant', variant.id);
      const image = variant && variant.featured_image && variant.featured_image.src || root.dataset.image || '';
      return {variantTitle, sku, url: productUrl.toString(), image};
    }
    function compose() {
      const data = context();
      const customerName = read('[name="contact[name]"]').value.trim();
      const customerEmail = read('[name="contact[email]"]').value.trim();
      const customerPhone = read('[name="contact[phone]"]').value.trim();
      const message = read('[name="contact[body]"]').value.trim();
      const kind = type.value;
      const fields = [
        ['Enquiry type', kind], ['Product', root.dataset.title],
        ['Variant', data.variantTitle], ['SKU', data.sku], ['Product URL', data.url]
      ];
      if (data.image) fields.push(['Product image', data.image]);
      if (customerName) fields.push(['Name', customerName]);
      if (customerEmail) fields.push(['Email', customerEmail]);
      if (customerPhone) fields.push(['Telephone', customerPhone]);
      if (message) fields.push(['Message', message]);
      const whatsappLines = ['Enquiry to Blackbeancoffee.africa', ''];
      const emailLines = ['Enquiry to Blackbeancoffee.africa', '', 'PRODUCT ENQUIRY', ''];
      for (const [label, value] of fields) {
        if (label === 'Name') emailLines.push('', 'CUSTOMER DETAILS', '');
        if (label === 'Message') emailLines.push('');
        whatsappLines.push('*' + label + ':* ' + value);
        emailLines.push(label + ': ' + value);
      }
      return {data, kind, whatsappBody:whatsappLines.join('\n'), emailBody:emailLines.join('\n')};
    }
    function update() {
      const p = compose();
      read('[data-bbca-variant]').textContent = p.data.variantTitle;
      read('[data-bbca-sku]').textContent = 'SKU: ' + p.data.sku;
      read('[data-bbca-field-variant]').value = p.data.variantTitle;
      read('[data-bbca-field-sku]').value = p.data.sku === 'Not specified' ? '' : p.data.sku;
      read('[data-bbca-field-url]').value = p.data.url;
      read('[data-bbca-field-image]').value = p.data.image;
      read('[data-bbca-field-type]').value = p.kind;
      const img = read('[data-bbca-preview-image]');
      if (img && p.data.image && img.dataset.bbcaImage !== p.data.image) {
        img.src = p.data.image;
        img.dataset.bbcaImage = p.data.image;
      }
      wa.href = 'https://wa.me/27836525423?text=' + encodeURIComponent(p.whatsappBody);
      email.href = 'mailto:info@blackbeancoffee.africa?subject=' +
        encodeURIComponent(p.kind + ' — ' + root.dataset.title) + '&body=' + encodeURIComponent(p.emailBody);
    }
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', update);
    wa.addEventListener('click', update);
    email.addEventListener('click', () => {
      update();
      const notice = read('[data-bbca-email-status]');
      if (notice) {
        notice.hidden = false;
        notice.focus({preventScroll:true});
        notice.scrollIntoView({block:'nearest', behavior:'auto'});
      }
    });
    document.addEventListener('change', e => {
      if (e.target.closest('variant-selects,variant-radios,product-info,form[action*="/cart/add"]')) {
        setTimeout(update, 80);
      }
    });
    document.addEventListener('variant:change', update);
    document.addEventListener('variant:changed', update);
    window.addEventListener('popstate', update);
    let oldUrl = location.href;
    const observer = new MutationObserver(() => {
      if (location.href !== oldUrl) { oldUrl = location.href; update(); }
    });
    observer.observe(document.querySelector('main') || document.body, {subtree:true, childList:true});
    update();
    const success = read('[data-bbca-success]');
    if (success) {
      details.open = true;
      requestAnimationFrame(() => {
        success.scrollIntoView({block:'center', behavior:'auto'});
        success.focus({preventScroll:true});
      });
    }
  }
  document.querySelectorAll('[data-bbca-enquiry]').forEach(init);
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-bbca-enquiry]').forEach(init));
})();